import Splide from "@splidejs/splide";

export function initWorksDetailPageEffects() {
  const splideInit = () => {
    const init = () => {
      // ギャラリー要素の存在確認
      const mainElement = document.querySelector("#main-carousel");
      const thumbnailElement = document.querySelector("#thumbnail-carousel");

      // 要素が存在しない場合は初期化しない
      if (!mainElement || !thumbnailElement) return;

      // スライドの存在確認
      const mainSlides = mainElement.querySelectorAll(".splide__slide");
      const thumbnailSlides = thumbnailElement.querySelectorAll(".splide__slide");

      // スライドが1枚もない場合は初期化しない
      if (mainSlides.length === 0 || thumbnailSlides.length === 0) return;

      const main = new Splide("#main-carousel", {
        type: "fade",
        rewind: true,
        pagination: false,
        arrows: false,
      });

      const thumbnails = new Splide("#thumbnail-carousel", {
        type: "slide",
        perPage: 3,
        perMove: 1,
        gap: 16,
        rewind: true,
        pagination: false,
        // cover: true,
        isNavigation: true,
        // fixedHeight: 176,
        // autoWidth: true,
        // fixedWidth: 176,
        classes: {
          arrows: "splide__arrows works-splide-arrows",
          arrow: "splide__arrow works-splide-arrow",
          prev: "splide__arrow--prev works-splide-arrow-prev",
          next: "splide__arrow--next works-splide-arrow-next",
        },
        breakpoints: {
          688: {
            gap: 4,
          },
        },
      });

      main.sync(thumbnails);
      main.mount();
      thumbnails.mount();
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  };

  splideInit();
}
